module.exports = __webpack_public_path__ + "img/category-sport.681df6bc.png";